<template>
  <FormularView />
</template>

<script>
import FormularView from "../src/components/FormularView.vue"; // adjust the path according to your project structure

export default {
  components: {
    FormularView,
  },
};
</script>
